export class Forgotpassword {
    phone_type:string="91";
    mobile:string;
    pass1:string;
    pass2:string;
    pass3:string;
    pass4:string;
    pass5:string;
    pass6:string;
    password:string;
    confirm_password:string;
}
